import { render, staticRenderFns } from "./LoginProfessional.vue?vue&type=template&id=66a7a298&scoped=true"
import script from "./LoginProfessional.vue?vue&type=script&lang=ts"
export * from "./LoginProfessional.vue?vue&type=script&lang=ts"
import style0 from "./LoginProfessional.vue?vue&type=style&index=0&id=66a7a298&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7a298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66a7a298')) {
      api.createRecord('66a7a298', component.options)
    } else {
      api.reload('66a7a298', component.options)
    }
    module.hot.accept("./LoginProfessional.vue?vue&type=template&id=66a7a298&scoped=true", function () {
      api.rerender('66a7a298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/components/LoginProfessional.vue"
export default component.exports